import { convertToHTML, mapHTMLElements } from './string';


/**
 * Get language field of translations.
 *
 * @param {any[]} translations
 * @param {string} language
 * @param {string} field
 * @param {boolean} isHTML default value false
 * @returns {string | React.ReactNode}
 */
export function getLanguageField(translations, language, field, isHTML = false, mapHtml = false, htmlClass = "") {
    if(!translations) return '';
    for (const translation of translations) {
        if (translation.language?.code !== language && translation.languages_code?.code !== language && translation.languages_code !== language && translation.language !== language) continue;
        if (translation[field] === null) translation[field] = '';
        if (isHTML && mapHtml)
        {
            if(!translation[field]) return null;
            return convertToHTML(mapHTMLElements(translation[field], htmlClass));
        }
        if (isHTML) return convertToHTML(translation[field]);
        return translation[field];
    }
    return '';
}
